module.exports = __webpack_public_path__ + "files/ac8ffeafddae21aa9fc0a65cbf9bbf8d.png";